import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGIN_USER_SSO, LOGOUT_USER } from "./actionTypes";
import { loginSuccess, apiError, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";
import { revalidateAvailability } from "../../availability/actions";
import { clearDateStorage } from "../../../pages/Authentication/helpers";

function* loginUser({ payload: { user, history, token } }) {
  try {
    const response = yield call(
      axios.post,
      "/login",
      token
        ? {}
        : {
            email: user.email,
            password: user.password,
            slug: user.slug,
            recaptcha_token: user?.recaptcha_token,
          },
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response?.data?.data
    ) {
      if (response.data.data.passwordExpired) {
        const token = response.data.data.token;
        history.push({
          pathname: "/expire-password",
          state: { token: token }
        });
        return; 
      }

      let responseData = response.data.data;

      if (!response?.data?.data?.permissions["real_automation"]) {
        delete response?.data?.data?.AuthorizationRA;
      }
      //save Last User data
      const userData = {
        name: responseData.user.name,
        email: responseData.user.email,
        company: responseData.company.name,
        url_avatar: responseData.user.url_avatar,
      };

      localStorage.setItem("lastUser", JSON.stringify(userData));

      // Set Axios Default Header
      axios.defaults.headers.common["Authorization"] =
        responseData.Authorization;

      // Set Profile Picture (prevent cache)
      responseData.user.url_avatar = responseData.user?.url_avatar
        ? responseData.user.url_avatar + "?time=" + new Date().getTime()
        : null;

      // Set localStorage authUser
      localStorage.setItem("authUser", JSON.stringify(responseData));

      // Set localStorage status
      const avail = responseData.availabilities?.find((e) => e.default === "1");

      yield put(revalidateAvailability(avail?.id));

      yield put(loginSuccess(responseData));
      clearDateStorage();
      history.push("/dashboard");
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* logoutUser({ payload: { history, isExpired = false } }) {
  const authData = JSON.parse(localStorage.getItem("authUser"));

  if (isExpired === false) {
    try {
      const response = yield call(axios.post, "/user/logout");
      if (
        !(
          (response.status >= 200 || response.status <= 299) &&
          response?.data?.data
        )
      ) {
        throw response.data;
      }
    } catch (error) {
      console.error(error);
    } finally {
      delete axios.defaults.headers.common["Authorization"];
      yield put(logoutUserSuccess());

      if (authData?.sso_logout_url)
        window.location.href = authData?.sso_logout_url;

      if (history) history.push("/login");
    }
  }

  localStorage.removeItem("authUser");
  localStorage.removeItem("availabilities");
}

function* loginUserSSO({ payload: { code_authorization, slug, history } }) {
  try {
    const response = yield call(axios.post, "/auth/token", {
      code_authorization,
      slug,
    });

    if (
      (response.status >= 200 || response.status <= 299) &&
      response?.data?.data
    ) {
      let responseData = response.data.data;

      if (!response?.data?.data?.permissions["real_automation"]) {
        delete response?.data?.data?.AuthorizationRA;
      }

      //save Last User data
      const userData = {
        name: responseData.user.name,
        email: responseData.user.email,
        company: responseData.company.name,
        url_avatar: responseData.user.url_avatar,
      };

      localStorage.setItem("lastUser", JSON.stringify(userData));

      // Set Axios Default Header
      axios.defaults.headers.common["Authorization"] =
        responseData.Authorization;

      // Set Profile Picture (prevent cache)
      responseData.user.url_avatar = responseData.user?.url_avatar
        ? responseData.user.url_avatar + "?time=" + new Date().getTime()
        : null;

      // Set localStorage authUser
      localStorage.setItem("authUser", JSON.stringify(responseData));

      // Set localStorage status
      const avail = responseData.availabilities?.find((e) => e.default === "1");

      yield put(revalidateAvailability(avail.id));

      yield put(loginSuccess(responseData));
      history.push("/dashboard");
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchUserLoginSSO() {
  yield takeEvery(LOGIN_USER_SSO, loginUserSSO);
}

export function* watchUserLogin() {
  yield takeEvery(LOGIN_USER, loginUser);
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser);
}

function* authSaga() {
  yield all([
    fork(watchUserLogin),
    fork(watchUserLogout),
    fork(watchUserLoginSSO),
  ]);
}

export default authSaga;
